import React from 'react';

function Menu() {
  return (
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top " id="mainNav">
          <div className="container">
              <a className="navbar-brand js-scroll-trigger" href="#page-top">Мангаа</a>
              <button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
              Menu
              <i className="fas fa-bars"></i>
              </button>
              <div className="collapse navbar-collapse" id="navbarResponsive">
              <ul className="navbar-nav ml-auto">
                  <li className="nav-item">
                  <a className="nav-link js-scroll-trigger" href="#download">Татах</a>
                  </li>
                  <li className="nav-item">
                  <a className="nav-link js-scroll-trigger" href="#features">Мангаа App</a>
                  </li>
                  <li className="nav-item">
                  <a className="nav-link js-scroll-trigger" href="#mangaTeam">MАНГАА TEAM</a>
                  </li>
                  <li className="nav-item">
                  <a className="nav-link js-scroll-trigger" href="#donat">ХАНДИВ</a>
                  </li>
              </ul>
              </div>
          </div>
      </nav>
  );
}

export default Menu;
